(() => {
  const GUMMIES_HANDLE = "gummies-vinaigre-de-cidre-nektar";
  const VINEGAR_REFILL_HANDLE = "recharge-de-vinaigre-nektar";
  const GUMMIES_TWO_POT_OFFER = "b8be0918-cdc2-430c-8330-7ee2667d3a3e";
  const SUBSCRIPTION_DISCOUNT = 15;

  let scheduled = false;

  function bundleData(item) {
    try {
      return JSON.parse(item.properties?.__moonbundle || "{}");
    } catch {
      return {};
    }
  }

  function isGummies(item) {
    return item.handle === GUMMIES_HANDLE;
  }

  function isGummiesTwoPotBundle(item) {
    return isGummies(item) && bundleData(item).offer_id === GUMMIES_TWO_POT_OFFER;
  }

  function hasGummiesBundleDiscount(item) {
    const discounts = [
      ...(item.discounts || []),
      ...(item.line_level_discount_allocations || []).map((allocation) => (
        allocation.discount_application || {}
      ))
    ];
    return isGummies(item) && discounts.some((discount) => (
      discount.title?.trim().toLocaleLowerCase() === "cure 2 mois"
    ));
  }

  function money(cents, currency = "EUR") {
    return new Intl.NumberFormat(document.documentElement.lang || "fr-FR", {
      style: "currency",
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(cents / 100);
  }

  function originalUnitPrice(item) {
    const quantity = Math.max(1, Number(item.quantity || 1));
    return Number(
      item.compare_at_price
      || item.selling_plan_allocation?.compare_at_price
      || item.original_price
      || Math.round(Number(item.original_line_price || item.final_line_price || 0) / quantity)
    );
  }

  function correctSubscriptionSaving(item) {
    const quantity = Math.max(1, Number(item.quantity || 1));
    const originalUnit = originalUnitPrice(item);
    const originalTotal = originalUnit * quantity;

    if (item.selling_plan_allocation) {
      return Math.max(0, originalTotal - Number(item.final_line_price || 0));
    }

    const subscriptionUnit = Math.round(originalUnit * (1 - (SUBSCRIPTION_DISCOUNT / 100)));
    return Math.max(0, originalTotal - (subscriptionUnit * quantity));
  }

  function decorateLine(drawer, item) {
    if (!isGummies(item) && item.handle !== VINEGAR_REFILL_HANDLE) return;

    const row = [...drawer.querySelectorAll(".moonbundle-cart-item")]
      .find((element) => element.dataset.itemKey === item.key);
    if (!row) return;

    const subscription = row.querySelector(".moonbundle-subscribe-save-section");
    const badge = row.querySelector(".moonbundle-free-gift-badge");
    const isBundle = isGummiesTwoPotBundle(item) || hasGummiesBundleDiscount(item);

    row.classList.toggle("nektar-gummies-bundle-line", isBundle);

    if (isBundle) {
      if (subscription) subscription.style.setProperty("display", "none", "important");
      if (badge && badge.textContent.trim() !== "Offre 2 pots") {
        badge.textContent = "Offre 2 pots";
      }
      row.querySelectorAll(".moonbundle-quantity-btn").forEach((button) => {
        button.disabled = true;
        button.setAttribute("aria-disabled", "true");
        button.title = "Cette offre contient exactement 2 pots";
      });
      const quantityInput = row.querySelector(".moonbundle-quantity-input");
      if (quantityInput) {
        quantityInput.readOnly = true;
        quantityInput.title = "Cette offre contient exactement 2 pots";
      }
      return;
    }

    const title = row.querySelector(".moonbundle-subscribe-title");
    const subtitle = row.querySelector(".moonbundle-subscribe-subtitle");
    const saving = row.querySelector(".moonbundle-subscribe-savings");
    const discount = row.querySelector(".moonbundle-cart-item-discount");
    const savingAmount = correctSubscriptionSaving(item);
    let subscriptionBadge = row.querySelector(".nektar-subscription-line-badge");

    if (item.selling_plan_allocation) {
      if (!subscriptionBadge) {
        subscriptionBadge = document.createElement("div");
        subscriptionBadge.className = "moonbundle-free-gift-badge nektar-subscription-line-badge";
        row.querySelector(".moonbundle-cart-item-title")?.insertAdjacentElement("afterend", subscriptionBadge);
      }
      if (subscriptionBadge.textContent.trim() !== "(Abonnement)") {
        subscriptionBadge.textContent = "(Abonnement)";
      }
      if (title) title.textContent = "Abonnement actif";
      if (subtitle) subtitle.textContent = `${SUBSCRIPTION_DISCOUNT} % de réduction`;
      if (discount && savingAmount > 0) discount.textContent = `-${money(savingAmount, drawer.cart?.currency)}`;
    } else {
      subscriptionBadge?.remove();
      if (title) title.textContent = "Souscrire";
      if (subtitle) subtitle.textContent = `Économisez ${SUBSCRIPTION_DISCOUNT} % sur ce produit`;
    }

    if (saving && savingAmount > 0) {
      saving.textContent = `Vous économisez ${money(savingAmount, drawer.cart?.currency)}`;
    }
  }

  function sync() {
    const drawer = document.querySelector("moonbundle-cart-drawer-block");
    const items = drawer?.cart?.items;
    if (!drawer || !Array.isArray(items)) return;

    items.forEach((item) => decorateLine(drawer, item));
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      sync();
    });
  }

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
  document.documentElement.addEventListener("cart:change", schedule);
  document.documentElement.addEventListener("variant:add", schedule);
  schedule();
})();
